/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const calendarAuthorizationUrlResponseSchema = z.object({
	authorizationUrl: z.string(),
})

export type CalendarAuthorizationUrlResponseSchema = z.infer<typeof calendarAuthorizationUrlResponseSchema>
